/* TOA November 2026: standalone poster. No cookies, analytics, cart or checkout writes. */
(function () {
  'use strict';
  var root = document.getElementById('toa-november-offers-2026');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  var dialog = root.querySelector('dialog');
  var launch = root.querySelector('[data-offer-launch]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  var end = Date.parse(root.dataset.end);
  var start = Date.parse(root.dataset.start);
  var key = 'toa-monthly-offers-2026-11-seen';
  var image = root.querySelector('[data-offer-image]');
  var stage = root.querySelector('[data-offer-stage]');
  var zoom = root.querySelector('[data-offer-zoom]');
  var fit = root.querySelector('[data-offer-fit]');
  var toolbar = root.querySelector('[data-offer-zoom-toolbar]');
  var previousFocus = null;
  var oldOverflow = '';
  var oldPadding = '';
  var wasSeen = false;
  var expiryTimer;
  var autoTimer;
  function active() { var now = Date.now(); return now >= start && now < end; }
  function seen() { try { return window.sessionStorage.getItem(key) === '1'; } catch (_) { return wasSeen; } }
  function markSeen() { wasSeen = true; try { window.sessionStorage.setItem(key, '1'); } catch (_) {} }
  function setZoom(large) {
    dialog.classList.toggle('is-zoomed', large);
    toolbar.hidden = !large;
    zoom.setAttribute('aria-pressed', String(large));
    if (large) {
      image.src = image.dataset.largeSrc;
      stage.scrollTop = 0; stage.scrollLeft = 0;
      fit.focus();
    } else {
      stage.scrollTop = 0; stage.scrollLeft = 0;
      if (dialog.open) zoom.focus();
    }
  }
  function close() { if (dialog.open) dialog.close(); }
  function expire() {
    clearTimeout(autoTimer); clearTimeout(expiryTimer);
    close(); root.hidden = true;
  }
  function open() {
    if (!active()) { expire(); return; }
    if (dialog.open) return;
    previousFocus = document.activeElement;
    oldOverflow = document.body.style.overflow;
    oldPadding = document.body.style.paddingRight;
    var scrollbar = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    try { dialog.showModal(); } catch (_) { return; }
    launch.hidden = true;
    document.body.style.overflow = 'hidden';
    if (scrollbar) document.body.style.paddingRight = scrollbar + 'px';
    markSeen();
    root.querySelector('[data-offer-close]').focus();
  }
  function anotherDialog() {
    var candidates = document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], #shopify-pc__banner, #onetrust-banner-sdk, .cc-window, #CybotCookiebotDialog, .cmplz-cookiebanner');
    return Array.prototype.some.call(candidates, function (node) {
      return node !== dialog && !root.contains(node) && node.getAttribute('aria-hidden') !== 'true' && node.getClientRects().length > 0;
    });
  }
  function autoOpen() {
    if (!active()) { expire(); return; }
    var blocked = document.hidden || anotherDialog();
    launch.hidden = blocked || dialog.open;
    if (blocked) { autoTimer = setTimeout(autoOpen, 1200); return; }
    if (seen()) return;
    open();
  }
  dialog.addEventListener('close', function () {
    document.body.style.overflow = oldOverflow;
    document.body.style.paddingRight = oldPadding;
    setZoom(false);
    launch.hidden = !active();
    if (previousFocus && previousFocus.isConnected && typeof previousFocus.focus === 'function') previousFocus.focus();
  });
  dialog.addEventListener('click', function (event) {
    if (event.target !== dialog) return;
    var rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  dialog.addEventListener('cancel', function (event) {
    if (dialog.classList.contains('is-zoomed')) { event.preventDefault(); setZoom(false); }
  });
  root.querySelectorAll('[data-offer-close]').forEach(function (button) { button.addEventListener('click', close); });
  root.querySelector('[data-offer-poster]').addEventListener('click', function () { if (!dialog.classList.contains('is-zoomed')) setZoom(true); });
  zoom.addEventListener('click', function () { setZoom(true); });
  fit.addEventListener('click', function () { setZoom(false); });
  launch.addEventListener('click', open);
  document.addEventListener('visibilitychange', function () { if (!active()) expire(); });
  window.addEventListener('pageshow', function () { if (!active()) expire(); });
  if (!active()) { expire(); return; }
  launch.hidden = false;
  // Browser timeout limit: recheck at least hourly and exactly at the end of the campaign.
  function scheduleExpiry() {
    expiryTimer = setTimeout(function () { if (!active()) expire(); else scheduleExpiry(); }, Math.min(3600000, Math.max(0, end - Date.now())));
  }
  scheduleExpiry();
  autoTimer = setTimeout(autoOpen, 1200);
}());
